:root {
  color: #f7f7f2;
  background: #12211d;
  font-family: Inter, ui-sans-serif, system-ui, sans-serif;
  font-synthesis: none;
}

body {
  min-width: 320px;
  min-height: 100vh;
  margin: 0;
}

.foundation-shell {
  box-sizing: border-box;
  max-width: 760px;
  min-height: 100vh;
  padding: clamp(3rem, 10vw, 8rem) clamp(1.5rem, 7vw, 5rem);
}

.eyebrow {
  color: #a8d6c5;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

h1 {
  max-width: 12ch;
  margin: 1rem 0;
  font-size: clamp(2.75rem, 9vw, 5rem);
  line-height: 0.95;
}

p {
  max-width: 56ch;
  color: #d4ded9;
  line-height: 1.65;
}

.transport-status {
  display: inline-block;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  background: #234d42;
  color: #d7f4e7;
  font-size: 0.85rem;
  font-weight: 700;
}

.client-form {
  display: grid;
  gap: 0.8rem;
  max-width: 32rem;
  margin: 2rem 0;
}

label {
  display: grid;
  gap: 0.3rem;
  color: #a8d6c5;
  font-size: 0.85rem;
  font-weight: 700;
}

input {
  box-sizing: border-box;
  width: 100%;
  padding: 0.7rem;
  border: 1px solid #44675b;
  border-radius: 0.5rem;
  color: #f7f7f2;
  background: #1a322b;
  font: inherit;
}

button {
  width: fit-content;
  padding: 0.65rem 1rem;
  border: 0;
  border-radius: 999px;
  color: #12211d;
  background: #a8d6c5;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

h2 {
  margin-top: 2.5rem;
}

.client-list {
  display: grid;
  gap: 0.65rem;
  max-width: 42rem;
  padding: 0;
  list-style: none;
}

.client-list li {
  display: grid;
  gap: 0.2rem;
  padding: 0.9rem 1rem;
  border: 1px solid #315148;
  border-radius: 0.7rem;
  background: #172c26;
}

.client-list span,
.client-list small {
  color: #b8cdc5;
}

.sync-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin: 1.25rem 0;
}

.sync-status {
  color: #a8d6c5;
  font-size: 0.85rem;
  font-weight: 600;
}

.custom-fields-panel {
  margin: 1rem 0;
  padding: 0.8rem;
  border: 1px dashed #3e6356;
  border-radius: 0.6rem;
  background: #142520;
}

.custom-fields-panel h3 {
  margin: 0 0 0.6rem 0;
  font-size: 0.95rem;
  color: #a8d6c5;
}

.custom-field-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.custom-field-row input {
  flex: 1;
}

.custom-fields-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.35rem;
}

.custom-field-tag {
  display: inline-block;
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
  background: #234d42;
  color: #d7f4e7;
  font-size: 0.75rem;
  font-weight: 600;
}

.pipeline-stages-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin: 1rem 0;
  padding: 0.4rem;
  background: #10211c;
  border-radius: 0.6rem;
  border: 1px solid #23453a;
}

.pipeline-stage-tab {
  background: #172c26;
  color: #a8d6c5;
  border: 1px solid #2d4f43;
  padding: 0.35rem 0.7rem;
  border-radius: 0.4rem;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.pipeline-stage-tab:hover {
  background: #23453a;
  color: #ffffff;
}

.pipeline-stage-tab.active {
  background: #2f855a;
  border-color: #48bb78;
  color: #ffffff;
  font-weight: 700;
}

.client-card-item {
  cursor: pointer;
  transition:
    transform 0.1s ease,
    border-color 0.15s ease;
}

.client-card-item:hover {
  border-color: #4da382;
  transform: translateY(-1px);
}

.client-card-item.selected {
  border-color: #48bb78;
  box-shadow: 0 0 0 2px #2f855a;
}

.client-stage-badge {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  background: #213f36;
  color: #7ee2b8;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin: 0.25rem 0;
}
